import { DesktopIcon } from '@phosphor-icons/react';
import { useState } from 'react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { PageHeader } from '@/modules/common';

import { useFetch } from '../../common/hooks/useFetch';

export const DownloadsPage = () => {
  const fetchClient = useFetch();
  const [isDownloadingLauncher, setIsDownloadingLauncher] = useState(false);

  const handleDownloadLauncher = async () => {
    try {
      setIsDownloadingLauncher(true);
      const { downloadUrl } = await fetchClient<{ downloadUrl: string }>(
        '/launcher/download-url',
        { method: 'GET' },
      );
      const link = document.createElement('a');
      link.href = downloadUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      toast.error(error.message ?? 'Failed to get download link');
    } finally {
      setIsDownloadingLauncher(false);
    }
  };

  return (
    <div>
      <PageHeader title="Downloads" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <Card>
          <CardHeader>
            <div className="flex items-center gap-3">
              <DesktopIcon size={32} className="text-zinc-300 shrink-0" />
              <div>
                <CardTitle>Desktop Launcher</CardTitle>
                <CardDescription className="mt-1">
                  Runs kiosk instances on your computer
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-zinc-400">
              Required for operating events. Detects your OS automatically — supports macOS and Windows.
            </p>
          </CardContent>
          <CardFooter>
            <Button
              onClick={handleDownloadLauncher}
              isLoading={isDownloadingLauncher}
              className="w-full"
            >
              Download
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
};
